export default "__VITE_ASSET__CK0HPCG5__"